export default "__VITE_ASSET__CRyk4chx__"